import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  styles,
  Hero,
  SectionHeader,
  CTASection,
} from "../../../components/landing/SharedComponent";

const Blog = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Karyanto Herlambang",
      position: "Direktur",
      image: "images/landing/blog_page/reren.png",
      description: "Memimpin PT. Adhim Aju Sejahtera dengan visi ke depan",
      quote:
        "Kualitas dan kepuasan pelanggan adalah fondasi utama kesuksesan perusahaan kami.",
    },
    {
      id: 2,
      name: "M Haidar Hafizh Fikri",
      position: "Kepala Divisi Operasional",
      image: "images/landing/blog_page/reren1.jpg",
      description: "Ahli dalam manajemen operasional dan pengembangan strategi",
      quote:
        "Efisiensi operasional adalah kunci untuk memberikan pelayanan terbaik dan tepat waktu kepada klien.",
    },
    {
      id: 3,
      name: "Annisa Nur Afina",
      position: "Personalia & Keuangan",
      image: "images/landing/blog_page/reren2.jpg",
      description: "Mengelola sumber daya manusia dan keuangan perusahaan",
      quote:
        "Tim yang solid dan kesehatan finansial adalah dua pilar penting dalam keberlanjutan perusahaan.",
    },
    {
      id: 4,
      name: "Maskuri Junaedi",
      position: "Kepala Laboratorium & Development",
      image: "images/landing/blog_page/reren.png",
      description: "Ahli pengembangan dan inovasi teknologi material",
      quote:
        "Inovasi dan penelitian berkelanjutan adalah kunci untuk tetap kompetitif di industri ini.",
    },
    {
      id: 5,
      name: "Jamil Tirta Parigi",
      position: "Kepala Departemen Teknis",
      image: "images/landing/blog_page/reren1.jpg",
      description: "Spesialis dalam perencanaan dan implementasi teknis",
      quote:
        "Ketelitian dalam detail teknis menentukan kualitas hasil akhir setiap proyek yang kita kerjakan.",
    },
    {
      id: 6,
      name: "Febriansyah",
      position: "Kepala Satuan Jaminan Mutu",
      image: "images/landing/blog_page/reren2.jpg",
      description: "Memastikan standar kualitas tertinggi dalam setiap aspek",
      quote:
        "Konsistensi dalam penerapan standar mutu adalah investasi jangka panjang untuk kepercayaan klien.",
    },
  ];

  // State for team member slider with auto-change
  const [currentTeamMember, setCurrentTeamMember] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);

  // Auto-change team member every 5 seconds
  useEffect(() => {
    let interval;

    if (isAutoplay) {
      interval = setInterval(() => {
        setCurrentTeamMember((prev) => (prev + 1) % teamMembers.length);
      }, 5000);
    }

    return () => clearInterval(interval);
  }, [isAutoplay, teamMembers.length]);

  // Pause autoplay when user interacts with controls
  const handleManualChange = (direction) => {
    setIsAutoplay(false);

    if (direction === "next") {
      setCurrentTeamMember((prev) => (prev + 1) % teamMembers.length);
    } else {
      setCurrentTeamMember(
        (prev) => (prev - 1 + teamMembers.length) % teamMembers.length
      );
    }

    setTimeout(() => setIsAutoplay(true), 10000);
  };

  const galleryImages = [
    {
      id: 1,
      title: "Instalasi Proyek",
      category: "Lapangan",
      image: "images/landing/blog_page/project_installation.png",
      date: "Maret 2025",
    },
    {
      id: 2,
      title: "Pengujian Kualitas",
      category: "Laboratorium",
      image: "images/landing/blog_page/lab_testing.png",
      date: "Februari 2025",
    },
    {
      id: 3,
      title: "Pelatihan Tim",
      category: "Pengembangan",
      image: "images/landing/blog_page/team_training.png",
      date: "Januari 2025",
    },
    {
      id: 4,
      title: "Survei Lokasi",
      category: "Lapangan",
      image: "images/landing/blog_page/site_survey.png",
      date: "Desember 2024",
    },
  ];

  const newsUpdates = [
    {
      id: 1,
      title: "PT. Adhim Aju Sejahtera Meraih Sertifikasi ISO",
      description:
        "Komitmen kami terhadap manajemen mutu dan standar lingkungan telah diakui dengan sertifikasi ISO terbaru.",
      image: "images/landing/blog_page/news-1.jpg",
      date: "15 Maret 2025",
      category: "Prestasi",
    },
    {
      id: 2,
      title: "Ekspansi Fasilitas Laboratorium",
      description:
        "Peralatan berteknologi tinggi baru telah ditambahkan untuk meningkatkan kemampuan pengujian dan penelitian kami.",
      image: "images/landing/blog_page/news-2.jpg",
      date: "28 Februari 2025",
      category: "Pengembangan",
    },
    {
      id: 3,
      title: "Partisipasi dalam Konferensi Industri",
      description:
        "Tim kami berbagi wawasan tentang kemajuan teknologi terbaru pada konferensi industri tahunan.",
      image: "images/landing/blog_page/news-3.jpg",
      date: "10 Februari 2025",
      category: "Acara",
    },
  ];

  const achievements = [
    {
      number: "300+",
      title: "Proyek Selesai",
      description: "Berhasil menyelesaikan proyek di berbagai industri",
    },
    {
      number: "40+",
      title: "Anggota Tim Ahli",
      description: "Profesional terampil yang berdedikasi pada keunggulan",
    },
    {
      number: "12+",
      title: "Tahun Pengalaman",
      description: "Melayani industri dengan keahlian dan inovasi",
    },
    {
      number: "100%",
      title: "Kepuasan Klien",
      description: "Berkomitmen untuk melampaui harapan klien",
    },
  ];

  // Simplified animation variants
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Hero
        title="Berita & Galeri"
        subtitle="Jelajahi Perjalanan dan Prestasi Kami"
        backgroundImage="/images/landing/bg.png"
      />

      {/* Team Members Slider Section */}
      <section className={`${styles.container} ${styles.sectionSpacing}`}>
        <motion.div
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeIn}
        >
          <SectionHeader title="Tim Kami" />
          <div className="py-12">
            <div className="bg-transparent rounded-lg overflow-hidden">
              <div className="flex flex-col md:flex-row">
                {/* Left side - Image */}
                <div className="w-full md:w-1/2 h-[500px] flex items-center justify-center">
                  <motion.div
                    className="relative"
                    key={`image-${currentTeamMember}`}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <img
                      src={teamMembers[currentTeamMember].image}
                      alt={teamMembers[currentTeamMember].name}
                      className="w-[450px] h-[450px] object-cover rounded-full border-4 border-primary shadow-lg"
                    />
                  </motion.div>
                </div>

                {/* Right side - Info with Quote */}
                <div className="w-full md:w-1/2 p-6 flex flex-col justify-center">
                  <motion.div
                    key={`info-${teamMembers[currentTeamMember].id}`}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.5 }}
                    className="relative"
                  >
                    {/* Quote marks */}
                    <div className="absolute -left-4 -top-8 text-5xl text-primary opacity-20">
                      "
                    </div>

                    {/* Quote content */}
                    <p className="text-lg italic text-gray-700 mb-5 pl-4">
                      {teamMembers[currentTeamMember].quote}
                    </p>

                    <div className="mt-4 border-l-4 border-primary pl-4">
                      <h3 className="text-2xl font-bold text-gray-800">
                        {teamMembers[currentTeamMember].name}
                      </h3>
                      <p className="text-lg text-primary font-medium mt-1">
                        {teamMembers[currentTeamMember].position}
                      </p>
                      <p className="text-gray-600 mt-3">
                        {teamMembers[currentTeamMember].description}
                      </p>
                    </div>
                  </motion.div>

                  {/* Navigation arrows */}
                  <div className="flex justify-between mt-6">
                    <button
                      onClick={() => handleManualChange("prev")}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 p-2 rounded-full transition-colors"
                      aria-label="Previous team member"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    </button>
                    <div className="text-gray-500 text-sm">
                      {currentTeamMember + 1} / {teamMembers.length}
                    </div>
                    <button
                      onClick={() => handleManualChange("next")}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 p-2 rounded-full transition-colors"
                      aria-label="Next team member"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Company Gallery Section */}
      <section className={`${styles.container} ${styles.sectionSpacing}`}>
        <motion.div
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-50px" }}
          variants={staggerContainer}
        >
          <SectionHeader title="Galeri Perusahaan" />
          <motion.div
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 py-12"
            variants={staggerContainer}
          >
            {galleryImages.map((item) => (
              <motion.div
                key={item.id}
                variants={fadeIn}
                className={`bg-white rounded-lg ${styles.shadowBase} overflow-hidden group`}
                whileHover={{ y: -5, transition: { duration: 0.3 } }}
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105`}
                  />
                </div>
                <div className="p-4">
                  <span className="text-sm text-primary font-medium">
                    {item.category}
                  </span>
                  <h3 className="text-lg font-semibold mt-1">{item.title}</h3>
                  <p className="text-sm text-gray-600 mt-1">{item.date}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </section>

      {/* Achievements Section */}
      <section className="bg-primary py-16">
        <motion.div
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-50px" }}
          variants={fadeIn}
          className={styles.container}
        >
          <h2 className={`${styles.sectionTitle} text-white text-center mb-12`}>
            Prestasi Kami
          </h2>
          <motion.div
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
            variants={staggerContainer}
          >
            {achievements.map((achievement, index) => (
              <motion.div
                key={index}
                variants={fadeIn}
                className="text-center text-white"
                whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
              >
                <div className="text-4xl font-bold mb-2">
                  {achievement.number}
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  {achievement.title}
                </h3>
                <p className="text-white/80">{achievement.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </section>

      {/* News & Updates Section */}
      <section className="bg-white py-16">
        <motion.div
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-50px" }}
          variants={fadeIn}
          className={styles.container}
        >
          <SectionHeader title="Berita & Informasi Terbaru" />
          <motion.div
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 py-12"
            variants={staggerContainer}
          >
            {newsUpdates.map((news) => (
              <motion.div
                key={news.id}
                variants={fadeIn}
                className={`bg-gray-50 rounded-lg ${styles.shadowBase} overflow-hidden`}
                whileHover={{ y: -8, transition: { duration: 0.3 } }}
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={news.image}
                    alt={news.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-sm text-primary font-medium">
                      {news.category}
                    </span>
                    <span className="text-sm text-gray-500">•</span>
                    <span className="text-sm text-gray-500">{news.date}</span>
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{news.title}</h3>
                  <p className="text-gray-600">{news.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </section>

      <CTASection
        title="Tetap Terhubung"
        subtitle="Berlangganan newsletter kami untuk informasi dan berita terbaru"
        buttonText="Berlangganan Sekarang"
        buttonLink="/subscribe"
      />
    </div>
  );
};

export default Blog;
